import { TranslateService } from './../../shared/translate/translate.service';
import { Directive, ElementRef, EventEmitter, Output, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { FlatPickrModel } from './flatpickr.model';

const $ = require("jquery");
const moment = require("moment");
const Flatpickr = require("flatpickr");
//const Flatpickr = require("../../../../public/plugin/flatpickr/final/flatpickr.min.js");

// declare var Flatpickr: any;
// declare var $: any;
// declare var moment: any;

@Directive({
  selector: '[flatpickr]',
  exportAs: 'wego-flatpickr',
})
export class FlatPickrDirective implements OnInit, OnChanges, OnDestroy {
  private _defultConfig: FlatPickrModel;
  @Input() ngModel: string;
  @Output() ngModelChange = new EventEmitter();
  @Input() Config: FlatPickrModel;
  private el: HTMLElement;
  private picker: any;
  private isAlreadyChange = false;
  private defaultDate: string;
  constructor(_el: ElementRef
    , private translate: TranslateService) {
    this.el = _el.nativeElement;
  }

  ngOnChanges(change: any) {
    this.defaultDate = change.ngModel.currentValue;
    if (this.picker && !this.isAlreadyChange && this.defaultDate) {
      let format = this.Config.noCalendar ? 'HH:mm' : this.Config.enableSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
      let newDate = moment(this.defaultDate, format).toDate();//this.picker.parseDate(this.defaultDate);
      this.picker.setDate(newDate, "Change");
      this.isAlreadyChange = true;
    }
  }

  ngOnInit() {
    this.InitializePicker();
  }

  public InitializePicker() {
    this.translate.setDetectedLang();
    Flatpickr.l10ns.default.weekdays = this.translate.instant('LblWeekdays');
    Flatpickr.l10ns.default.months = this.translate.instant('LblMonths');


    if (this.defaultDate) {
      let format = this.Config.noCalendar ? 'HH:mm' : this.Config.enableSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
      let newDate = moment(this.defaultDate, format).toDate();
      this.Config.defaultDate = newDate;
    }

    this.Config.onReady = (dateObj: any, dateStr: any, instance: any) => {
      var LblCancel = this.translate.instant('LblCancel');
      var LblSave = this.translate.instant('LblSave');
      var extraPanel = `<div class="flatpickr-close" style="padding: 5px 0px;border-top: 1px solid #e6e6e6;">
                          <button class="btn flatpickr-btn-clear" style="padding: 2px; width: 45%;">`
        + LblCancel +
        `</button>
                          <button class="btn flatpickr-btn-check" style="padding: 2px; width: 45%;">`
        + LblSave +
        `</button>
                        </div>`;
      var $cal = $(instance.calendarContainer);
      if ($cal.find('.flatpickr-clear').length < 1) {
        $cal.append(extraPanel);
        $cal.find('.flatpickr-btn-check').on('click', function () {
          instance.close();
        });
        $cal.find('.flatpickr-btn-clear').on('click', function () {
          instance.clear();
          instance.close();
        });
      }
    }

    this.picker = new Flatpickr(this.el, this.Config);
    this.picker.config.onChange = (dateObj: any, dateStr: any, instance: any) => {
      this.ngModelChange.emit(dateStr);
    }
  }

  public ChangeValue(newVal: string) {
    let format = this.Config.noCalendar ? 'HH:mm' : this.Config.enableSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
    let newDate = moment(newVal, format).toDate();//this.picker.parseDate(this.defaultDate);
    this.picker.setDate(newDate, "Change");
  }

  public SetOption(configKey: string, value: any) {
    this.picker.set(configKey, value)
  }

  public ToggleTimePicker(enableTime: boolean) {
    this.Config.enableTime = enableTime;
    this.picker.destroy();
    this.isAlreadyChange = false;
    this.InitializePicker();
  }

  public ToggleDatePickerFormat(enableTime: boolean,dateFormat: string) {
    this.Config.enableTime = enableTime;
    this.Config.dateFormat = dateFormat;
    this.picker.destroy();
    this.isAlreadyChange = false;
    this.InitializePicker();
  }
  ngOnDestroy() {
    this.picker.destroy();
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/plugins/flatpickr/flatpickr.directive.ts